// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

Vue.config.productionTip = false

const EventBus = new Vue();

/* eslint-disable no-new */
var app = new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  methods: {
    // backPressedMain() {
    //   console.log("Main Back Pressed");
    // }
  },
  // mounted () {
  //   document.addEventListener("backbutton", this.backPressedMain, false);
  // },
  // beforeDestroy () {
  //   document.removeEventListener("backbutton", this.backPressedMain);
  // }
})



// WEBPACK FOOTER //
// ./src/main.js